import { IconsProps } from "./dto";

export function ArrivalIcon(props: IconsProps) {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width={props.size} height={props.size} viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                fill={props.color} stroke="none">
                <path d="M2055 4626 c-37 -16 -82 -68 -92 -104 -4 -15 18 -286 49 -602 31
-316 54 -577 52 -579 -6 -6 -594 152 -609 163 -7 6 -50 119 -94 251 -82 239
-99 273 -151 300 -30 15 -361 105 -387 105 -33 -1 -100 -37 -121 -66 -26 -37
-281 -985 -289 -1074 -16 -182 94 -376 259 -458 44 -22 320 -100 928 -262 785
-210 1792 -480 2523 -676 384 -103 389 -104 436 -92 102 26 144 138 144 388 0
129 -3 168 -21 235 -82 297 -298 522 -612 636 -36 13 -224 67 -419 119 l-354
95 -286 711 c-157 391 -294 723 -304 737 -9 15 -30 33 -45 41 -37 19 -518 146
-551 146 -14 -1 -40 -7 -56 -14z m362 -391 l48 -15 285 -712 c213 -533 293
-721 315 -746 25 -27 48 -39 115 -57 47 -12 231 -62 410 -110 371 -99 440
-123 539 -189 159 -106 260 -288 261 -470 0 -48 0 -48 -29 -43 -17 4 -443 117
-948 252 -505 136 -1084 291 -1288 346 -203 54 -579 155 -834 223 -271 73
-475 132 -489 143 -14 11 -34 31 -45 44 -39 53 -35 81 77 498 59 217 108 397
111 399 2 2 19 -1 37 -7 33 -11 34 -14 113 -247 84 -249 100 -283 137 -308 28
-18 982 -276 1022 -276 66 0 139 59 151 124 5 26 -80 982 -102 1135 l-6 44 36
-7 c19 -4 57 -13 84 -21z"
                />
                <path d="M255 786 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 26 -8
737 -10 2314 -8 l2277 3 27 21 c53 39 69 71 69 134 0 63 -16 95 -69 134 l-27
21 -2287 2 c-1886 2 -2292 0 -2317 -11z"/>
            </g>
        </svg>

    )
}